<template>
  <div class="comment-module">
    <div class="mark">
      <div class="title">
        会员满意度：
      </div>
      <div class="mark-start">
        <div
          v-for="i in 5"
          :key="i"
          class="mark-start-item active"
        />
      </div>
      <p class="score">
        4.68
      </p>
    </div>

    <div class="comment">
      <div
        v-for="(item, index) in viewModel.commentList"
        :key="index"
        class="comment-item"
      >
        <div class="avatar">
          <img
            :src="item.avatar"
            alt=""
          >
        </div>
        <div class="name">
          {{ item.name }}
        </div>
        <div class="content">
          {{ item.content }}
        </div>
      </div>

      <p class="comment-status">
        {{ viewModel.commentStatus }}
      </p>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, onMounted, onUnmounted } from '@vue/composition-api'
import { PAGE_NUM } from '@/config/dataMap'
import { getCommentInfoRequest } from '@/api/user'

// 评论状态描述
const COMMENT_DESC = {
  PENDING: '数据正在加载中...',
  NO_MORE: '没有更多了',
}
export default defineComponent({
  name: 'CommentModule',
  setup (props, context) {
    const viewModel = reactive({
      commentList: [],
      isExistData: true, // 是否还存在分页数据
      lastCommentId: 0, // 当前最后一个评论的ID，作为服务端分页查询数据的游标
      commentStatus: '',
    })
    onMounted(async () => {
      await getCommentInfo()
      window.app.$EventBus.$on('handleScrollEvent', handleScroll)
    })
    onUnmounted(() => {
      window.app.$EventBus.$off('handleScrollEvent', handleScroll)
    })

    // 处理滚动事件
    function handleScroll (e) {
      const event = e.target
      // 网页总高度
      const scrollHeight = event.scrollHeight
      // 滚动条距离顶部距离
      const scrollTop = event.scrollTop
      // 可视窗口高度
      const clientHeight = event.clientHeight

      // 滚动条距离顶部距离 + 可视窗口高度 >= 网页总高度（说明滚动到底部了，进行数据请求）
      if (scrollTop + clientHeight >= scrollHeight) {
        if (!viewModel.isExistData) return
        viewModel.commentStatus = COMMENT_DESC.PENDING
        getCommentInfo()
      }
    }

    // 获取评论数据方法封装
    function getCommentInfo () {
      viewModel.isExistData = false
      const paramsObj = {
        pay_from: PAGE_NUM[context.root.$route.name],
        index_id: viewModel.lastCommentId,
      }
      getCommentInfoRequest(paramsObj).then(res => {
        if (res.resp_common.ret === 0) {
          viewModel.commentList = viewModel.commentList.concat(res.feedback_list)
          viewModel.isExistData = res.has_more
          viewModel.lastCommentId = res.latest_index_id

          if (!res.has_more) {
            viewModel.commentStatus = COMMENT_DESC.NO_MORE
          } else {
            viewModel.commentStatus = ''
          }
        }
      })
    }
    return {
      viewModel
    }
  }
})
</script>

<style scoped lang="scss">
.comment-module {
  margin-top: 15px;
  padding: 0 51px;

  .mark {
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    .title {
      color: #333;
      font-size: 14px;
      font-weight: 600;
    }
    .mark-start {
      display: flex;
      .mark-start-item {
        margin-left: 4px;
        width: 20px;
        height: 20px;
        background-image: url('./_images/start-default.png');
        background-size: cover;
        &:after {
          content: '';
          display: block;
          width: 100%;
          height: 100%;
          background-image: url('./_images/start-active.png');
          background-size: cover;
        }

        &:last-child::after {
          width: calc(0.68 / 1 * 100%);
        }
      }
    }
    .score {
      margin-left: 16px;
      padding-top: 2px;
      font-size: 20px;
      font-weight: 600;
      color: #FFA421;
    }
  }

  .comment {
    .comment-item {
      display: flex;
      align-items: center;
      padding: 16px 0;
      font-size: 14px;
      color: #333;
      border-bottom: 1px solid #F0F0F0;
      &:last-child {
        padding-bottom: unset;
        border-bottom: none;
      }
      .avatar {
        height: 48px;
        width: 48px;
        overflow: hidden;
        border-radius: 50%;
        flex: 0 0 48px;
        background-size: contain;
        img {
          width: 100%;
        }
      }
      .name {
        margin-left: 12px;
        flex: 0 0 50px;
      }
      .content {
        margin-left: 61px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }

    .comment-status {
      margin-top: 25px;
      font-size: 14px;
      font-weight: 400;
      line-height: 13px;
      text-align: center;
      color: #999999;
    }
  }
}
</style>
